// Helpers shared by the filter drawers and their applied-filter chips.

// A multi-select filter value can be an array of option objects (from the
// control), an array of ids, or a comma-separated id string (from the URL).
// Resolve any of them to option objects for the select's `value`.
export const resolveMultiValue = (raw, options = []) => {
  if (raw === null || raw === undefined || raw === "") return [];
  const ids = Array.isArray(raw)
    ? raw.map((v) => (v && typeof v === "object" ? v.value : v))
    : String(raw).split(",").map((id) => id.trim());
  return ids
    .filter((id) => id !== "" && id !== null && id !== undefined)
    .map((id) => options.find((opt) => String(opt.value) === String(id)) || { value: id, label: String(id) });
};

// Raw value of a filter key from the drawer's filters array.
export const filterValueOf = (filters, key) => filters?.find((f) => f.key === key)?.value ?? "";

export const filterHasValue = (filters, key) => {
  const v = filterValueOf(filters, key);
  return Array.isArray(v) ? v.length > 0 : v !== "" && v !== null && v !== undefined;
};

export const countActive = (filters, keys) => keys.filter((key) => filterHasValue(filters, key)).length;

// "3,7" + a lookup list -> "Kitchen, Bar" for the applied-filter chips.
// Unknown ids are shown as-is so a stale URL never renders an empty chip.
export const namesFor = (raw, list, idOf, labelOf) => {
  const ids = String(raw ?? "").split(",").map((id) => id.trim()).filter(Boolean);
  const names = ids.map((id) => {
    const found = list?.find((item) => String(idOf(item)) === id);
    return found ? labelOf(found) : id;
  });
  return names.length ? names.join(", ") : String(raw ?? "");
};
